import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as documentUpload from '../document-upload'

/** Agent-specific knowledge-base source and document management workspace. */
@ngCore.Component({
  imports: [
    ds.input.select.single.Component,
    ds.layout.widget.Component,
    ds.table.Component,
    documentUpload.Component,
  ],
  selector: 'atn-admin-knowledge-bases-page-agent-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Route-bound collection shared with the page and Shared tab. */
  public readonly filesEc = ngCore.inject(
    state.admin.agentKnowledgeBases.Collection,
  )

  /** Canonical embedded table input for agent knowledge-base documents. */
  public readonly documentsTableConfig = {
    collection: this.filesEc,
    view: {
      container: 'embedded' as const,
      pagination: true,
      showColumnSettings: false,
      title: 'Documents',
    },
  } satisfies ds.table.ec.Config.Input<state.admin.agentKnowledgeBases.TypeParams>

  /** Converts manageable agents into options for the agent selector. */
  public getAgentItems(
    agents: readonly ents.core.agent.KnowledgeBase.Management.Agent[],
  ): readonly ds.input.select.models.Item<ents.core.agent.Agent.Id>[] {
    return agents.map(agent => ({
      label: agent.agentName,
      value: agent.agentId,
    }))
  }

  /** Converts one agent's manageable sources into selector options. */
  public getDataSourceItems(
    agent: ents.core.agent.KnowledgeBase.Management.Agent | undefined,
  ): readonly ds.input.select.models.Item<ents.core.agent.KnowledgeBase.Management.DataSource>[] {
    return (agent?.dataSources ?? []).map((dataSource, index) => ({
      label: dataSource.description ?? `Data source ${index + 1}`,
      value: dataSource,
    }))
  }
}
